var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.125C0 0.515625 0.46875 0 1.125 0H16.875C17.4844 0 18 0.515625 18 1.125C18 1.78125 17.4844 2.25 16.875 2.25H16.5V3.14062C16.5 5.0625 15.75 6.84375 14.3906 8.20312L10.5469 12L14.3906 15.8438C15.75 17.1562 16.5 18.9844 16.5 20.8594V21.75H16.875C17.4844 21.75 18 22.2656 18 22.875C18 23.5312 17.4844 24 16.875 24H1.125C0.46875 24 0 23.5312 0 22.875C0 22.2656 0.46875 21.75 1.125 21.75H1.5V20.8594C1.5 18.9844 2.25 17.1562 3.5625 15.8438L7.40625 12L3.5625 8.20312C2.25 6.84375 1.5 5.0625 1.5 3.14062V2.25H1.125C0.46875 2.25 0 1.78125 0 1.125ZM5.15625 17.4375C4.96875 17.625 4.82812 17.8125 4.64062 18H13.3125C13.1719 17.8125 12.9844 17.625 12.7969 17.4375L9 13.5938L5.15625 17.4375ZM13.3125 6C13.9219 5.20312 14.25 4.17188 14.25 3.14062V2.25H3.75V3.14062C3.75 4.21875 4.07812 5.20312 4.64062 6H13.3125Z",
    fill: "#F4BA34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.f7502a90981304b0a0d5377a0d8b4383.svg";
export { ForwardRef as ReactComponent };